import { render, staticRenderFns } from "./Incident.vue?vue&type=template&id=5bb4b753&scoped=true"
import script from "./Incident.vue?vue&type=script&lang=ts"
export * from "./Incident.vue?vue&type=script&lang=ts"
import style0 from "./Incident.vue?vue&type=style&index=0&id=5bb4b753&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4b753",
  null
  
)

export default component.exports